module.exports = __webpack_public_path__ + "img/mimogzh.a3cf7957.png";